// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper_2htHB","map":"index_map_30KOP"};